export { default } from './TwoColumnTextBlock';
export * from './TwoColumnTextBlock';
